import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Breadcrumb, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  documentsList,
  addTemplates,
  categoryList,
} from "../../../store/actions";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { MenuItem, Select } from "@material-ui/core";
import Loading from "../../../Common/extra/loading";

const Default = [
  {
    name: "Yes",
    id: "1",
  },
  {
    name: "No",
    id: "0",
  },
];

const AddServiceProviderIndex = () => {
  const EditId = location.pathname.split("/")[3];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState({
    name: "",
    documents: [],
    template_categories_id: "",
    default_template: "",
  });
  const [loading, setLoading] = useState(false);
  const Documents = useSelector((s) => s?.Documents?.documents?.data);
  const Categories = useSelector((s) => s?.Categories?.categories?.data);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((pre) => ({ ...pre, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const callBack = (res) => {
      setLoading(false);
      if (res.data) {
        toast.success("Template Added Successfully");
        navigate("/templates");
      }
    };
    dispatch(
      addTemplates(
        {
          name: data.name,
          documents: JSON.stringify(data.documents),
          template_categories_id: data.template_categories_id,
          default_template: data.default_template,
        },
        callBack
      )
    );
  };

  useEffect(() => {
    dispatch(documentsList());
    dispatch(categoryList());
  }, []);
  return (
    <>
      {loading && <Loading className={"cstmLoader"} />}
      <section className="dashboard profile-main py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <Breadcrumb>
                  <Breadcrumb.Item href="/templates">
                    Document Template
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active>
                    {EditId ? "Edit" : "Add"}
                  </Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="py-2">
                <div className="bg-white card-box px-4 py-3 rounded">
                  <Form>
                    <Row>
                      <Col lg="6" className="my-2">
                        <label htmlFor="" className="form-label2 m-0">
                          Template Name
                        </label>
                        <input
                          type="text"
                          placeholder=""
                          className="form-control"
                          value={data?.name}
                          name="name"
                          onChange={handleChange}
                        />
                        <span className="note error_note py-2 m-0 text-danger">
                          {/* {errors.name} */}
                        </span>
                      </Col>
                      <Col lg="6" className="my-2 doc-select">
                        <label htmlFor="" className="form-label2 m-0">
                          Template Category
                        </label>
                        <Select
                          className="demo-simple-select-label"
                          id="demo-simple-select"
                          name="template_categories_id"
                          value={data.template_categories_id}
                          onChange={handleChange}
                          MenuProps={Categories}
                        >
                          {Categories &&
                            Categories.length > 0 &&
                            Categories.map((item, idx) => {
                              return (
                                <MenuItem key={item.id} value={item.id}>
                                  {item.name}
                                </MenuItem>
                              );
                            })}
                        </Select>
                      </Col>
                      <Col lg="6" className="my-2 doc-select">
                        <label htmlFor="" className="form-label2 m-0">
                          Select Documents
                        </label>
                        <Select
                          className="demo-simple-select-label"
                          id="demo-simple-select"
                          multiple
                          name="documents"
                          value={data.documents}
                          onChange={handleChange}
                          MenuProps={Documents}
                        >
                          {Documents &&
                            Documents.length > 0 &&
                            Documents.map((item, idx) => {
                              return (
                                <MenuItem key={item.id} value={item.id}>
                                  {item.name}
                                </MenuItem>
                              );
                            })}
                        </Select>
                      </Col>
                      <Col lg="6" className="my-2 doc-select">
                        <label htmlFor="" className="form-label2 m-0">
                          Make Default Template
                        </label>
                        <Select
                          className="demo-simple-select-label"
                          id="demo-simple-select"
                          name="default_template"
                          value={data.default_template}
                          onChange={handleChange}
                          MenuProps={Default}
                        >
                          {Default &&
                            Default.length > 0 &&
                            Default.map((item, idx) => {
                              return (
                                <MenuItem key={item.id} value={item.id}>
                                  {item.name}
                                </MenuItem>
                              );
                            })}
                        </Select>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </div>

              <div className="py-2">
                <Row>
                  <Col lg="12" className="my-2">
                    <div className="pt-3 btn-wrp d-flex algign-items-center">
                      <Button
                        disabled={
                          data.documents.length !== 0 &&
                          data.name !== "" &&
                          data.template_categories_id !== ""
                            ? false
                            : true
                        }
                        onClick={handleSubmit}
                        className="d-flex align-items-center justify-content-center me-2"
                      >
                        Submit
                      </Button>
                      <Link
                        to="/templates"
                        className="d-flex btn-2 border align-items-center justify-content-center me-2"
                      >
                        <span className="me-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="9"
                            viewBox="0 0 12 9"
                            fill="none"
                          >
                            <path
                              d="M2.8725 3.75L5.5575 1.0575L4.5 0L0 4.5L4.5 9L5.5575 7.9425L2.8725 5.25H12V3.75H2.8725Z"
                              fill="black"
                            />
                          </svg>
                        </span>
                        Back
                      </Link>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default AddServiceProviderIndex;
